import {Button, Result, Typography, theme} from "antd";
import {CloseCircleOutlined, WhatsAppOutlined} from "@ant-design/icons";
import { ArrowUpRight, LogOut } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { logout } from "../../services/auth";
const { Paragraph, Text, Link } = Typography;

export default function Blocked(){
  const navigate = useNavigate()
  const whatsappURL = "https://chat.whatsapp.com/D9lS6WAX6B5II9sOEhIl35?mode=ems_copy_t"

  const {
    token: {colorSider: bg},
  } = theme.useToken();

    return (
      <div style={{height: "100vh", width: '100%', overflow: 'hidden', background: bg, alignContent: 'center'}}>
        <Result
            status="error"
            title="Empresa bloqueada"
            subTitle="Por favor, entre em contato com o seu administrador."
            style={{
              margin: 'auto auto',
              width: '40%'
            }}
            extra={[
                <Link href={whatsappURL}>
                  <Button type="primary" key="console" icon={<WhatsAppOutlined size={12}/>}>
                    Contactar
                  </Button>
                </Link>,
                <Button
                  key="buy"
                  size="small"
                  icon={<LogOut size={16}/>}
                  type="text"
                  danger
                  onClick={() => {
                    logout(navigate)
                  }}
                >
                  Sair
                </Button>,
            ]}
        >
            <div className="desc">
                <Paragraph>
                    <Text
                        strong
                        style={{
                            fontSize: 16,
                        }}
                    >
                        O que aconteceu?
                    </Text>
                </Paragraph>
                <Paragraph>
                    <CloseCircleOutlined className="site-result-demo-error-icon" /> A empresa da qual você faz parte está bloqueada.
                </Paragraph>
                <Paragraph>
                    <CloseCircleOutlined className="site-result-demo-error-icon" /> Entre em contato para fazer o desbloqueio urgente. <a href={whatsappURL}>Entrar em contato <ArrowUpRight size={16}/></a>
                </Paragraph>
            </div>
        </Result>
      </div>
    )
}
